//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    IMPORT_P4_SEARCH_ACCOUNTS_REQUEST,
    IMPORT_P4_GET_STATUS_REQUEST,
    IMPORT_P4_IMPORT_REQUEST,
    IMPORT_P4_GET_ACCOUNT_BY_PX_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    accountsImportSearchAccountResult,
    accountsGetAccountByPxResult,
    accountsGetStatusResult,
    accountsImportResult,
} from 'Redux/actions';


function* searchExternalCompanies({ payload }) {
    const { openSearch, sourcePlatform } = payload
    try {
        let QUERY = `
            query searchExternalCompanies ($sourcePlatform: enumPlatform!, $openSearch: String!, $offset: Int!, $limit: Int!) {
                result: searchExternalCompanies (sourcePlatform: $sourcePlatform, openSearch: $openSearch, offset: $offset, limit: $limit) {
                    items
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                sourcePlatform,
                openSearch,
                limit: 1000,
                offset: 0,
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            const { items } = data?.result
            let accounts = items ? JSON.parse(items) : []
            yield put(accountsImportSearchAccountResult(accounts))
        }
        else {
            yield put(accountsImportSearchAccountResult([]))
        }

    } catch (exc) {
        yield put(accountsImportSearchAccountResult([]))
        ExceptionManager(exc, 'Modules/importP4/views/components/importAccounts/redux/saga', 'searchAccount');
    }
}

function* getCompanyMigrationStatus({ payload }) {
    const { externalCompanyId, sourcePlatform } = payload
    try {
        let QUERY = `
            query getCompanyMigrationStatus ($externalCompanyId: Int!, $sourcePlatform: enumPlatform!) {
                result: getCompanyMigrationStatus (externalCompanyId: $externalCompanyId, sourcePlatform: $sourcePlatform)
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                externalCompanyId,
                sourcePlatform,
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(accountsGetStatusResult(data?.result))

    } catch (error) {
        yield put(accountsGetStatusResult(null))
    }
}

function* importRecords({ payload }) {
    try {
        let QUERY = `
            mutation importRecords ($sourcePlatform: enumPlatform!, $externalCompanyId: Int!, $pairWithCompanyId: Int, $entities: [enumImportEntity]) {
                result: importRecords (sourcePlatform: $sourcePlatform, externalCompanyId: $externalCompanyId, pairWithCompanyId: $pairWithCompanyId, entities: $entities) {
                    stepFunctionId
                    processStartDate
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(accountsImportResult(data?.result))
        } else {
            yield put(accountsImportResult({ error: true }))
        }

    } catch (exc) {
        yield put(accountsImportResult({ error: exc }))
       // ExceptionManager(exc, 'Modules/importP4/views/components/importAccounts/redux/saga', 'importRecords');
    }
}

function* getCompanyByPx({ payload }) {
    try {
        let QUERY = `
        query searchCompanies ($conditions: [CompanySearchInput], $sort: [CompanySortInput], $limit: Int, $offset: Int) {
            result: searchCompanies (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                }
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                "conditions": {
                    "fields": [
                        "name"
                    ],
                    "terms": [payload],
                    "exact": true
                },
                limit: 1,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data.result
            yield put(accountsGetAccountByPxResult(items[0]))
        }

    } catch (exc) {
        yield put(accountsGetAccountByPxResult(null))
        ExceptionManager(exc, 'Modules/importP4/views/components/importAccounts/redux/saga', 'getCompanyByPx');
    }
}


function* watchCatalogRequests() {
    yield takeEvery(IMPORT_P4_SEARCH_ACCOUNTS_REQUEST, searchExternalCompanies);
    yield takeEvery(IMPORT_P4_GET_STATUS_REQUEST, getCompanyMigrationStatus);
    yield takeEvery(IMPORT_P4_IMPORT_REQUEST, importRecords);
    yield takeEvery(IMPORT_P4_GET_ACCOUNT_BY_PX_REQUEST, getCompanyByPx);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchCatalogRequests)
    ]);
}